<template>
  <div>
    <TopNavbar v-on:toogle-menu="toggleMenu" />
    <Sidebar :userName="userData.name" :isOpen="openMenu" @updateModule="updateModule" :modules="modulesItems" @changeHiddenButtonModules="changeHiddenButtonModules" v-on:toogle-menu="toggleMenu"/>

    <div class="profile-layout">
      <div class="main pb-5">
        <header class="section-header py-5">
          <p class="h4 text-primary mb-0 mt-2">Estás practicando el módulo</p>
          <h1 class="h4 text-dark mb-0 mt-2">{{selectedModule.description}}</h1>
        </header>
        <section class="container-fluid">
          <!-- Knowledge areas -->
          <div class="container">
            <div class="row">
              <div class="col d-flex justify-content-between pt-5 pb-3 banne-olimp">
                <!--<div>
                  <h2 class="h5">Áreas de conocimiento</h2>
                  <p>
                    Elige una de las áreas de conocimiento, para practicar
                    ejercicios aleatorios.
                  </p>
                </div>
                <div>
                  <select name="" id="" class="select">
                    <option value="today" selected>Hoy</option>
                    <option value="week">Esta semana</option>
                    <option value="month">Este Mes</option>
                    <option value="all">Todos</option>
                  </select>
                </div>-->
                  <div v-if="selectedModule.description === 'Olimpiadas'">
                    <b-card style="padding: 0">
                      <div class="card-container card-result module line-clamp" maxlength="1">

                        <div class="module line-clamp">
                          <p>
                          </p>
                        </div>

                        <p >
                          Este 16 de Abril a las 2 PM será la fase semifinal de las Olimpiadas de Matemáticas Mobius.
                          Para iniciar, ingresa en Iniciar Examen en Semi - Final.
                          Recuerda que una vez iniciado tienes  2 horas para terminar el examen.
                          Para más información visita <a href="https://www.mobiusml.com/olimpiadas">www.mobiusml.com/olimpiadas</a>
                          <br/><br/>
                          Te recomendamos hacer los simulacros como preparación para la olimpiada.

                        </p>
                      </div>

                    </b-card>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                v-for="course in courses"
                :key="course.title"
                class="col-sm-6 col-md-6 col-lg-4"
                v-bind:class="[{
                      'col-course':
                      (course.hidden == true &&
                        userPermission == 'ROLE_STUDENT') ||
                      userPermission == 'ROLE_SUPERVISOR',
                  },
                ]"
              >
              <div class="" v-if="course.hidden == false || userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR' ">
                <div class="card" >
                  <img
                    :src="$assetImport(`../assets/images/icons/${course.icon}.svg`)"
                    alt=""
                  />
                  <div class="shadow-mode" v-if="course.hidden == false || userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
                    <!-- <b-form-checkbox :disabled="permission()" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'"
                  @change="changeHiddenButtonCategories(course)" v-model="course.hidden" name="check-button" switch>
                    Ocultar
                  </b-form-checkbox> -->

                  <toggle-button :disabled="permission()" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'"
                    :font-size="10" class="button-check" @change="changeHiddenButtonCategories(course)"
                    :value="course.hidden" color="#cb1a1a !important" :labels="{checked: 'Off', unchecked: 'On'}"
                    DEFAULT_LABEL_CHECKED='off'/>

                  </div>
                  <p class="h5 mt-2" style="min-height: 48px">
                    {{ course.title }}
                  </p>

                  <div class="py-2">
                    <p class="mb-1">
                      Vistos {{ course.userAtempts.length }}/{{ course.questionsSize }}
                    </p>
                    <p class="mb-1">
                      <span class="badge-mini badge-mini__success mr-2"></span>
                      <b>{{  getUserCorrects(course.userAtempts)}}</b> correctos
                    </p>
                    <p class="mb-2">
                      <span class="badge-mini badge-mini__warning mr-2"></span>
                      <b>{{  getUserIncorrects(course.userAtempts)}}</b> incorrectos
                    </p>
                    <div class="progress-bar">
                      <div class="progress-bar-inner bg-warning" v-bind:style="'width:'+ getIncorrectPercetage(course) + '%'"></div>
                      <div class="progress-bar-inner bg-success" v-bind:style="'width:'+ getPercetage(course) + '%'"></div>
                    </div>
                  </div>

                  <div class="d-flex mt-2">
                    <button
                      class="btn bpito2tn-icon btn-secondary p-2 d-block"
                      @click="openCourseOverview(course)"
                    >
                      <IconifyIcon :icon="icons.bxSpreadsheet" height="24" />
                    </button>
                    <a
                      class="btn btn-secondary p-2 d-block w-100 ml-2"
                      @click="goToExercise(course.key)"
                    >
                      Practicar
                    </a>
                  </div>
                </div>
              </div>
              </div>

              <div
                v-for="simulacrum in simulacrums"
                :key="simulacrum.title"
                class="col-sm-12 col-md-6 col-lg-4"
                v-bind:class="[{'col-course':
                      (simulacrum.hidden == true &&
                        userPermission == 'ROLE_STUDENT') ||
                      userPermission == 'ROLE_SUPERVISOR',
                  },
                ]"
              >
                <div>
                <div class="card " v-if="simulacrum.hidden == false || userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'"
                v-bind:class="[{'red-condicional-tarjet' : cardfinished(simulacrum)},{'color-card' : cardStart(simulacrum)}]">
                  <img
                    :src="$assetImport(`../assets/images/icons/general.svg`)"
                    alt=""
                  />
                  <div class="shadow-mode" v-if="simulacrum.hidden == false || userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
                    <!-- <b-form-checkbox :disabled="permission()" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'"
                  @change="changeHiddenButtonSimulacrums(simulacrum)" v-model="simulacrum.hidden" name="check-button" switch>
                    Ocultar
                  </b-form-checkbox> -->

                  <toggle-button :disabled="permission()" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'"
                    :font-size="10" class="button-check" @change="changeHiddenButtonSimulacrums(simulacrum)"
                    :value="simulacrum.hidden" color="#cb1a1a !important" :labels="{checked: 'Off', unchecked: 'On'}"
                    DEFAULT_LABEL_CHECKED='off'/>

                  </div>

                  <p class="h5 mt-2" style="min-height: 48px">
                    {{ simulacrum.title }}
                  </p>

                  <div class="py-2">
                    <p v-if="simulacrum.duration >= 60">
                      Duración: {{ getTimeHours(simulacrum) }}
                      <span v-if="timeHours == 1"> hora</span>
                      <span v-else> horas</span>
                      {{ getTimeMinutes(simulacrum) }}
                      <span v-if="timeMinutes == 1">minuto</span>
                      <span v-else>minutos</span>
                    </p>
                    <p v-else class="mb-1">
                      Duración: {{ simulacrum.duration}}
                      <span v-if="simulacrum.duration == 1">minuto</span>
                      <span v-else>minutos</span>
                    </p>
                    <p class="mb-2">
                      Inicia: {{ simulacrum.startDate  | moment("MMM D, YYYY h:mm a") }}
                    </p>
                    <p class="mb-3">
                      Finaliza: {{ simulacrum.endDate  | moment("MMM D, YYYY h:mm a") }}
                    </p>
                  </div>

                  <div  class="d-flex mt-2" >

                    <button id="show-btn"  v-if="(getSimulacrumStatus(simulacrum) === 'unresolved')" v-bind:disabled="cardfinished(simulacrum)"
                      class="btn btn-secondary p-2 d-block w-100 ml-2"
                      @click="showModal(simulacrum)"
                    >
                      Iniciar examen
                    </button>
                    <button id="show-btn"  v-else-if="getSimulacrumStatus(simulacrum) === 'resolved'"
                      class="btn btn-secondary p-2 d-block w-100 ml-2"
                      @click="goToResults(simulacrum.id)"
                    >
                      Ver resultados
                    </button>

                  </div>
                </div>
              </div>
              </div>

              <b-modal no-close-on-backdrop ref="my-modal" hide-footer :title="selectedSimulacrum.title"> <p>Cuentas con {{selectedSimulacrum.duration}} minutos para resolverlo, comprueba que estas
                en un lugar tranquilo que te garantice contar con este tiempo.</p>

                <div>
                  <input type="checkbox" id="checkbox" v-model="checked">
                  <label class="label-checked" for="checkbox">Me comprometo a no hacer trampa</label>
                </div>

              <div class="row" >
                <div class="col col-sm-6 col-md-6 col-lg-6 text-center">
                  <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Cancelar</b-button>
                </div>

                <div class="col col-sm-6 col-md-6 col-lg-6 text-center">
                  <b-button class="mt-3" v-bind:disabled="checked == false" variant="outline-danger"
                  block @click="goToExerciseSimulacrum(selectedSimulacrum.key)">Continuar</b-button>
                </div>
              </div>

              </b-modal>



            </div>
          </div>
          <!-- End Knowledge areas -->

          <!-- Types of thinking -->
          <div class="container">
            <div class="row">
              <div class="col pt-5 pb-3">
                <h2 class="h5">Tipos de pensamiento</h2>
                <p>
                  El pensamiento matemático se complementa con el pensamiento
                  lógico, es el proceso de llevar las cosas de manera precisa a
                  sus esencias numéricas, estructurales o lógicas, y de analizar
                  los patrones subyacentes.
                </p>
              </div>
            </div>
            <div class="row">
              <div
                v-for="knowledgeArea in knowledgeAreas"
                :key="knowledgeArea.description"
                class="col-12 col-md-6"
              >
                <div class="card py-3 px-3 d-flex">
                  <div class="row">
                    <div class="d-flex align-items-center mr-1 col-2 col-md-1 ">
                      <img
                        :src="
                        $assetImport(`../assets/images/icons/${knowledgeArea.icon}.svg`)
                      "
                        alt=""
                      />
                    </div>
                    <div class="d-flex flex-column flex-md-column align-items-center w-100 col pl-4">
                      <p class="mb-0 font-weight-bold w-100">
                        {{ knowledgeArea ? knowledgeArea.description : "" }}
                      </p>
                      <div class="d-flex flex-md-column flex-lg-row align-items-lg-center w-100">
                        <p class="mb-0 w-100">
                          <b>{{ getUserCorrects(knowledgeArea.userAttempts) }}</b> correctos
                        </p>
                        <p class="mb-0 w-100">
                          <b>{{ knowledgeArea.userAttempts.length }}</b> vistos
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End Types of thinking -->
        </section>
      </div>
    </div>
    <modal
      name="course-overview"
      height="auto"
      :scrollable="true"
      :adaptive="true"
    >
      <div class="p-4">
        <h3>{{ selectedCourse.title }}</h3>
        <!-- TODO: Set image for Course overview -->
        <img src="@/assets/images/Geometria.png" alt="" class="img-fluid" />
        <div>
          <button class="btn btn-primary" @click="closeCourseOverview">
            Cerrar
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import TopNavbar from "@/components/TopNavbar.vue";
import axios from "axios";
import IconifyIcon from "@iconify/vue";
import bxSpreadsheet from "@iconify/icons-bx/bx-spreadsheet";

export default {
  name: "Dashboard",
  props: ["topic"],
  components: {
    TopNavbar,
    IconifyIcon,
    Sidebar,
  },
  data: () => {
    return {
      userData: {},
      courses: [],
      simulacrums: [],
      modulesItems: {},
      selectedModule: {},
      selectedCourse: {},
      knowledgeAreas: [],
      icons: {
        bxSpreadsheet,
      },
      simulacrumData: {},
      openMenu: false,
      selectedSimulacrum: {},
      displayDays: 0,
      displayHours: 0,
      displayMinutes: 0,
      displaySeconds: 0,
      isDisabled: false,
      end34: "",
      checked: false,
      color: true,
      color2: true,
      timeHours: 0,
      timeMinutes: 0,
      userPermission: '',
      bannerOlim: false,
    };
  },
  mounted: function () {
    if (window.opener) {
      window.opener.postMessage({
        type: 'googleAuth',
      }, window.location.origin);
    }
    this.userPermission =  localStorage.getItem("role");
    this.loadCourses();
    let loader = this.$loading.show({});

      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/knowledgeAreas/", {
          params: { },
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem("token")
          }
        })
        .then((response) => {
          loader.hide();
          let data = response.data;
          data.sort(function (a, b) {
            const textA = a.description ? a.description.toUpperCase() : "";
            const textB = b.description ? b.description.toUpperCase() : "";
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          });
          this.knowledgeAreas = data;
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });

    this.userData = this.$store.state.auth.data;
  },
  watch: {
    selectedModule: function() {

    },
  },
  methods: {
    cardfinished(simulacrum) {

      let daynow = new Date();
      let endDate1 = new Date(simulacrum.endDate);
      let startdate1 = new Date(simulacrum.startDate);

      if ((daynow > endDate1) || (daynow < startdate1)) {
        return true;
      } else {
        return false;
      }
    },
    permission() {
      if (this.userPermission == "ROLE_TEACHER") {
        return true;
      }
    },
    getSimulacrumStatus(simulacrum){
      if (simulacrum.simulacrumRegistry) {
        let simulacrumRegistry = simulacrum.simulacrumRegistry;
        let finishAt = new Date(simulacrumRegistry.finishAt);

        let finish = simulacrum.simulacrumRegistry.finish;
        let daynow = new Date();

        if (daynow > finishAt || finish) {

           return 'resolved'
        } else {
          return 'unresolved'
        }
      } else {
        return 'unresolved'
      }


    },
    convertTime(simulacrum) {

      this.timeMinutes = simulacrum.duration;
      this.timeHours = Math.floor(this.timeMinutes / 60);
      this.timeMinutes = this.timeMinutes % 60;

      if (simulacrum.duration > 60) {
        return true;
      } else {
        return false;
      }
    },
    getTimeHours(simulacrum) {
      let timeMinutes = simulacrum.duration;
      return Math.floor(timeMinutes / 60);
    },
    getTimeMinutes(simulacrum) {
      let timeMinutes = simulacrum.duration;
      return timeMinutes % 60;
    },
    cardStart(simulacrum) {

      let daynow = new Date();
      let endDate1 = new Date(simulacrum.endDate);
      let startdate1 = new Date(simulacrum.startDate);

      if ((daynow < endDate1) && (daynow >= startdate1)) {
        return true;
      } else {
        return false;
      }
    },
    showModal(simulacrum) {
      this.selectedSimulacrum = simulacrum;
      this.$refs['my-modal'].show();
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['my-modal'].toggle('#toggle-btn')
    },
    updateModule(module) {
      this.selectedModule = module;
      window.localStorage.setItem("selectedModule", module.id);
      this.loadCategories();
      this.loadSimulacrums();
    },
    loadCategories() {
      let loader = this.$loading.show({});
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/categories/getByModule/" + this.selectedModule.id, {
          params: { categoryKey: this.topic },
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem("token")
          }
        })
        .then((response) => {
          loader.hide();
          console.log(response)
          if(response.data === '') {
            this.courses = [];
            return;
          }
          let data= response.data;

          /*data.sort(function (a, b) {
            return parseInt(a.position) - parseInt(b.position);
          });*/

          this.courses = data;
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    changeHiddenButtonModules(module) {
      let loader = this.$loading.show({});
      axios
        .put(import.meta.env.VITE_API_BASE_URL + "/api/modules/changeshadowmode/" + module.id, { module: module.id},{
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem("token")
          }
        })
        .then(() => {
          loader.hide();

          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s(
            "Estado del curso cambiado"
          );

        })
        .catch((err) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
            "Falló al cambiar estado"
          );
          console.log(err.message);
          loader.hide();
        });
    },
    changeHiddenButtonCategories(categories) {
      let loader = this.$loading.show({});
      axios
        .put(import.meta.env.VITE_API_BASE_URL + "/api/categories/changeshadowmode/" + categories.id, { categories: categories.id},{
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem("token")
          }
        })
        .then(() => {
          loader.hide();

          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s(
            "Estado de la categoria cambiado"
          );

        })
        .catch((err) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
            "Falló al cambiar estado"
          );
          console.log(err.message);
          loader.hide();
        });
    },
    changeHiddenButtonSimulacrums(simulacrum) {
      let loader = this.$loading.show({});
      axios
        .put(import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/changeshadowmode/" + simulacrum.id, { simulacrum: simulacrum.id},{
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem("token")
          }
        })
        .then(() => {
          loader.hide();

          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s(
            "Estado del examen cambiado"
          );

        })
        .catch((err) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
            "Falló al cambiar estado, no se ha alcanzado el mínimo de preguntas"
          );
          simulacrum.hidden = true;
          console.log(err.message);
          loader.hide();
        });
    },
    loadSimulacrums() {
      let loader = this.$loading.show({});
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/getByModule/" + this.selectedModule.id, {

          params: { categoryKey: this.topic },
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem("token")
          }
        })
        .then((response) => {
          loader.hide();
          console.log(response)
          if(response.data === '') {
            this.simulacrums = [];
            return;
          }
          let data= response.data;

          /*data.sort(function (a, b) {
            return parseInt(a.position) - parseInt(b.position);
          });*/

          this.simulacrums = data;
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    loadCourses() {
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/api/modules/list",
          {
            params: { page: this.currentPage, size: this.perPage, sort: 'DESC', },
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {

          this.modulesItems = response.data;
          if (this.userPermission === "ROLE_STUDENT" || this.userPermission === "ROLE_SUPERVISOR") {
            this.modulesItems = this.modulesItems.filter(module => module.hidden == false && module.active == true);
          }
          this.selectedModule = this.modulesItems[0]
          let moduleSelected = window.localStorage.getItem("selectedModule");
          this.$nextTick(function() {
            if (moduleSelected) {


              this.selectedModule = this.modulesItems.find(module => module.id == moduleSelected)
              if (!this.selectedModule) {
                this.selectedModule = this.modulesItems[0]
                if (this.modulesItems[0]) {
                  window.localStorage.setItem("selectedModule", this.modulesItems[0].id);
                } else {
                  window.localStorage.removeItem("selectedModule");
                }
              }
              console.log(this.selectedModule)
            }else {
              this.selectedModule = this.modulesItems[0]
            }
            if(response.data.length > 0) {
              this.loadCategories();
              this.loadSimulacrums();
            }
          });



        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    toggleMenu() {
      this.openMenu = !this.openMenu;
    },
    goToExercise(topic) {
      this.$router.push(`/exercise/${topic}`);
    },
    goToResults(id) {
      this.$router.push(`/simulacrumResult/${id}`);
    },
    goToExerciseSimulacrum(topic) {
      this.$router.push(`/simulacrum/${topic}`);
    },
    getUserCorrects(attemps) {
      let correctAnswers = 0;
      attemps.forEach((element) => {
        const correct = element.answer ? element.answer.correct : element.openEndedCorrect === true;
        if (correct) correctAnswers++;
      });
      return correctAnswers;
    },
    getUserIncorrects(attemps) {
      let incorrectAnswers = 0;
      attemps.forEach((element) => {
        const correct = element.answer ? element.answer.correct : element.openEndedCorrect === true;
        if (!correct) incorrectAnswers++;
      });
      return incorrectAnswers;
    },
    getPercetage(course) {
      let numberQuestions = course.questionsSize;

      let correctAnswers = 0;
      let numberAttemps = course.userAtempts.length;
      course.userAtempts.forEach((element) => {
        const correct = element.answer ? element.answer.correct : element.openEndedCorrect === true;
        if (correct) correctAnswers++;
      });
      if (numberAttemps === 0) return 0;
      return (correctAnswers / numberQuestions) * 100;
    },
    getIncorrectPercetage(course) {
      const numberQuestions = course.questionsSize;
      const incorrectAnswers = this.getUserIncorrects(course.userAtempts);
      return (incorrectAnswers / numberQuestions) * 100;
    },
    openCourseOverview(course) {
      this.selectedCourse = course;
      this.$modal.show("Course-overview");
    },
    closeCourseOverview() {
      this.selectedCourse = {};
      this.$modal.hide("Course-overview");
    },
  },
  computed: {
  _seconds: () => 1000,
  _minutes() {
    return this._seconds * 60;
  },
  _hours() {
    return this._minutes * 60;
  },
  _days() {
    return this._hours * 24;
  },
  },
};
</script>

<style src="@/assets/css/app.css" scoped></style>
